import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid grid-cols-3 gap-3" }
const _hoisted_2 = { class: "text-sm text-gray-400" }
const _hoisted_3 = { class: "flex items-center justify-end mt-2" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times mr-2" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search mr-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_select = _resolveComponent("the-select")!
  const _component_the_input = _resolveComponent("the-input")!
  const _component_the_button = _resolveComponent("the-button")!

  return (_openBlock(), _createElementBlock("form", {
    class: "px-6 py-4 border bg-white",
    onSubmit: _cache[11] || (_cache[11] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_the_select, {
        "can-deselect": "",
        class: "mt-2",
        placeholder: "Тип",
        options: _ctx.TYPES,
        value: _ctx.state.writeOffTypeId,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.writeOffTypeId) = $event))
      }, null, 8, ["options", "value"]),
      _createVNode(_component_the_input, {
        placeholder: "Номер накладной",
        value: _ctx.state.invoiceNumber,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.invoiceNumber) = $event))
      }, null, 8, ["value"]),
      _createVNode(_component_the_input, {
        placeholder: "Дата создания от",
        value: _ctx.state.dateFrom,
        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.dateFrom) = $event)),
        type: "date"
      }, null, 8, ["value"]),
      _createVNode(_component_the_input, {
        placeholder: "Дата создания по",
        value: _ctx.state.dateTo,
        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.dateTo) = $event)),
        type: "date"
      }, null, 8, ["value"]),
      _createVNode(_component_the_select, {
        "can-deselect": "",
        placeholder: "Склады",
        loading: _ctx.data_state.warehouses.is_loading,
        failed: _ctx.data_state.warehouses.is_failed,
        "error-text": "При получении списка складов произошла ошибка",
        options: _ctx.data_state.warehouses.list,
        value: _ctx.state.warehouseId,
        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.warehouseId) = $event)),
        "search-by": "city",
        onRefresh: _ctx.loadWarehouses,
        class: "mt-2"
      }, {
        "selected-option": _withCtx(({ option }) => [
          _createTextVNode(" Склад " + _toDisplayString(option.city), 1)
        ]),
        option: _withCtx(({ option }) => [
          _createElementVNode("div", null, [
            _createElementVNode("p", null, "Склад " + _toDisplayString(option.city), 1),
            _createElementVNode("p", _hoisted_2, _toDisplayString(option.full_address), 1)
          ])
        ]),
        _: 1
      }, 8, ["loading", "failed", "options", "value", "onRefresh"]),
      _createVNode(_component_the_select, {
        "can-deselect": "",
        placeholder: "Доп. услуга",
        "error-text": "При получении списка доп. услуг произошла ошибка",
        options: _ctx.ADDITIONAL_SERVICES,
        searchable: false,
        value: _ctx.state.additionalServiceTypeId,
        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.additionalServiceTypeId) = $event)),
        class: "mt-2"
      }, null, 8, ["options", "value"]),
      _createVNode(_component_the_input, {
        placeholder: "Код 1С",
        value: _ctx.state.code1C,
        "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.code1C) = $event))
      }, null, 8, ["value"]),
      _createVNode(_component_the_select, {
        "can-deselect": "",
        class: "mt-2",
        placeholder: "ТМЦ",
        disabled: _ctx.data_state.tmc.is_loading,
        loading: _ctx.data_state.tmc.is_loading,
        failed: _ctx.data_state.tmc.is_failed,
        "error-text": "При получении списка ТМЦ произошла ошибка",
        options: _ctx.data_state.tmc.list,
        value: _ctx.state.inventoryItemIds,
        "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.inventoryItemIds) = $event)),
        "infinite-scroll": "",
        "search-by": "name",
        multiselect: "",
        onRefresh: _cache[8] || (_cache[8] = ($event: any) => (_ctx.loadTMC(_ctx.data_state.tmc.pagination.current_page))),
        onLoadmore: _cache[9] || (_cache[9] = ($event: any) => (_ctx.loadMoreTMC(_ctx.data_state.tmc.pagination.current_page + 1))),
        onSearch: _ctx.searchTMC,
        onOptionBySearch: _ctx.unshiftFindedTMC
      }, null, 8, ["disabled", "loading", "failed", "options", "value", "onSearch", "onOptionBySearch"]),
      _createVNode(_component_the_select, {
        "can-deselect": "",
        class: "mt-2",
        placeholder: "Плательщик",
        disabled: _ctx.data_state.companies.is_loading,
        loading: _ctx.data_state.companies.is_loading,
        failed: _ctx.data_state.companies.is_failed,
        "error-text": "При получении списка произошла ошибка",
        options: _ctx.data_state.companies.list,
        value: _ctx.state.payerCompanyIds,
        "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.payerCompanyIds) = $event)),
        "infinite-scroll": "",
        multiselect: "",
        onRefresh: _ctx.loadCompanies
      }, null, 8, ["disabled", "loading", "failed", "options", "value", "onRefresh"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_the_button, {
        class: "small second text mr-3",
        type: "button",
        loading: _ctx.loading,
        onClick: _ctx.onReset
      }, {
        default: _withCtx(() => [
          _hoisted_4,
          _createTextVNode(" Сбросить ")
        ]),
        _: 1
      }, 8, ["loading", "onClick"]),
      _createVNode(_component_the_button, {
        class: "small primary text",
        loading: _ctx.loading,
        type: "submit"
      }, {
        default: _withCtx(() => [
          _hoisted_5,
          _createTextVNode(" Поиск ")
        ]),
        _: 1
      }, 8, ["loading"])
    ])
  ], 32))
}